import React, { Component } from "react";
import Client from "../Client";
import BlackLoading from "../images/black-loader.gif";
import marked from "marked"; //to make font bold and headings

class FarmersmarketRawLocalHoney extends Component {
  constructor(props) {
    super(props);
    this.state = {
      farmersmarketRawLocalHoneypage: [],
    };
  }

  componentDidMount() {
    Client.getEntries({
      content_type: "farmersmarketRawLocalHoney",
    }).then((entries) => {
      this.setState({ farmersmarketRawLocalHoneypage: entries.items });
    });
  }

  //to make font bold and headings
  getParsedMarkdown(farmersmarketRawLocalHoneyDecs) {
    return {
      __html: marked(farmersmarketRawLocalHoneyDecs, { sanitize: true }),
    };
  }
  //to make font bold and headings - end

  render() {
    return (
      <div>
        {this.state.farmersmarketRawLocalHoneypage.length === 0 ? (
          <div align="center">
            <img src={BlackLoading} alt="Loading..." />
          </div>
        ) : (
          <div className="row">
            {this.state.farmersmarketRawLocalHoneypage.map((item, index) => {
              return (
                <div key={index} className="col-lg-12">
                  <div className="text-left pt-4">
                    {/* <h3>{item.fields.farmersmarketTitle}</h3> */}
                    <div dangerouslySetInnerHTML = {this.getParsedMarkdown(
                            item.fields.farmersmarketRawLocalHoneyDecs
                        )}></div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

    );
  }
}

export default FarmersmarketRawLocalHoney;
